import { useState } from 'react';
import { D, st } from '../constants.js';
import { BID_STATUS_BG, BID_STATUS_COLOR } from '../constants.js';
import { INVOICE_STATUS_BG, INVOICE_STATUS_COLOR } from '../constants.js';

export const getDirections = address => {
  if (!address) return;
  const encoded = encodeURIComponent(address);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  window.open(isIOS ? `https://maps.apple.com/?address=${encoded}` : `https://www.google.com/maps/search/?api=1&query=${encoded}`, '_blank');
};

export const Overlay = ({children, zIndex=100}) =>
  <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex,display:"flex",alignItems:"flex-start",justifyContent:"center",overflowY:"auto",padding:"20px 0"}}>{children}</div>;

export const MHdr = ({title, onClose}) =>
  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
    <div style={st.h2}>{title}</div>
    <button style={{...st.btn(),padding:"4px 10px"}} onClick={onClose}>✕</button>
  </div>;

export const Field = ({label, children}) =>
  <div style={{marginBottom:12}}>
    <label style={st.label}>{label}</label>
    {children}
  </div>;

export const BidBadge = ({status}) =>
  <span style={{background:BID_STATUS_BG[status]||"#eee",color:BID_STATUS_COLOR[status]||"#888",
    fontSize:11,fontWeight:500,padding:"2px 8px",borderRadius:6,
    border:`0.5px solid ${BID_STATUS_COLOR[status]||"#ccc"}`}}>{status}</span>;

export const InvoiceBadge = ({status}) =>
  <span style={{background:INVOICE_STATUS_BG[status]||"#eee",color:INVOICE_STATUS_COLOR[status]||"#888",
    fontSize:11,fontWeight:500,padding:"2px 8px",borderRadius:6,
    border:`0.5px solid ${INVOICE_STATUS_COLOR[status]||"#ccc"}`}}>{status}</span>;

export const StatGrid = ({stats}) =>
  <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))",gap:12,marginBottom:24}}>
    {stats.map((c,i) =>
      <div key={i} style={st.stat}>
        <div style={{fontSize:11,color:D.muted,marginBottom:6}}>{c.label}</div>
        <div style={{fontSize:22,fontWeight:500,color:c.color||D.text}}>{c.value}</div>
      </div>
    )}
  </div>;

export const AiBidNotes = ({notes}) => {
  const [expanded, setExpanded] = useState(false);
  const isLong = notes && notes.length > 100;
  return (
    <div style={{marginTop:8,fontSize:12,color:D.muted,lineHeight:1.6,background:D.surface,borderRadius:7,padding:"8px 12px",border:`1px solid ${D.border}`}}>
      {isLong && !expanded ? notes.slice(0,100)+"…" : notes}
      {isLong && <button style={{...st.btn(),padding:"2px 8px",fontSize:11,marginLeft:8}} onClick={()=>setExpanded(x=>!x)}>{expanded?"Less":"More"}</button>}
    </div>
  );
};
